import React from 'react'

class News extends React.Component {

}

export default News